import { getContentInnerPage } from "../api/getContentInnerPage.js";
import { postChangeChannels } from "../api/postChangeChannels.js";
import { formatTime_yn_mn_dn } from "@shared/utils/time/formated.js";

export default {
  namespaced: true,

  state: {
    list: {},
    renderMap: {},
    //ID поста, для которого планируются изменения
    editPostId: null,
    //Для редактора
    isEditMode: false,
    //Для выбора каналов
    channelsAbortController: null,
    //Костыль для исключения дублирования новых комментариев
    newCommentsId: [],
  },

  actions: {
    //Получаем данные внутренней страницы поста
    async loadAlphaData({commit, getters}){
      try {
        const idString = getters.getContentIdString;
        if(!idString) return; 
        const data = await getContentInnerPage(idString);
        commit('updatePostsData', data);
      } catch {
        console.error(`Ошибка при получении контеной части для Альфа:`);
      } finally {
        
      }
    },
    //Изменить каналы у поста
    async toChangeChannelsInPost({ state, commit }, { object_id, content_type, channel }) {
      try {
        const slug = channel.slug;
        commit('toChangeChannelInfo', { object_id, channel });
        await postChangeChannels({ object_id, content_type, slug });
      } catch (error) {
        console.error('Ошибка при изменении списка каналов:', error);
      }
    },
    //Добавляем посты в словарь и строим карту их отображения
    addItemsToList({ state, commit }, { alpha, isNew }){
      commit('addItems', { alpha, isNew });
      commit('sortRenderMap');
    }
  },

  mutations: {
    //Добавляем посты в словарь
    addItems(state, { alpha, isNew }) {
      Object.entries(alpha).forEach(([item, data]) => {
        if(!state.renderMap.hasOwnProperty(item)) state.renderMap[item] = [];
        const processPosts = (posts) => {
          posts.forEach((post) => {
            if (!state.renderMap[item].includes(post.id)){
              state.renderMap[item].unshift(post.id)
            }
            if(!state.list[post.id]?.is_ready_inner_page){
              if(isNew) post.is_new = isNew;
              state.list[post.id] = post;
            }
          });
        };
        if(data.pinned_posts?.length) processPosts(data.pinned_posts);
        if(data.posts?.length) processPosts(data.posts);
      });
    },
    //Сортируем карту отображения
    sortRenderMap(state) {
      Object.keys(state.renderMap).forEach(item => {
        state.renderMap[item] = state.renderMap[item].sort((a, b) => {
          const postA = state.list[a];
          const postB = state.list[b];
          const isPinnedA = postA?.pinned_day || postA?.pinned_all_time ? 1 : 0;
          const isPinnedB = postB?.pinned_day || postB?.pinned_all_time ? 1 : 0;
          if (isPinnedA !== isPinnedB) return isPinnedB - isPinnedA;
          const dateA = new Date(postA?.publication_date).getTime();
          const dateB = new Date(postB?.publication_date).getTime();
          return dateB - dateA;
        });
      });
    },
    //Добавляем полученные данные к объектам в списке
    updatePostsData(state, data){
      data.forEach((item) => {
        const id = item.id;
        const post = state.list[id];
        state.list[id] = {...item, ...post}
        state.list[id]['content'] = item['content'];
        state.list[id]['reactions'] = item['reactions'];
        state.list[id]['is_ready_inner_page'] = true;
        state.list[id]['podcast_atributes'] = item['podcast_atributes'];
        state.list[id]['embed_links'] = item['embed_links'];
      });
    },
    //Добавить пост в список и отобразить его в карте отрисовки
    toAddNewPost(state, data){
      const id = data.id;
      state.list[id] = data;
      state.list[id]['is_ready_inner_page'] = true;
      state.list[id]['model_name'] = state.list[id]['model_name'].toLowerCase();
      const mapKey = formatTime_yn_mn_dn(data.publication_date);
      if(!state.renderMap.hasOwnProperty(mapKey)) state.renderMap = { [mapKey]: [], ...state.renderMap }
      state.renderMap[mapKey].unshift(id);
    },
    //Добвить в список без рендера на странице
    toAddNewPostWithoutRender(state, post){
      const id = post.id;
      state.list[id] = post;
      state.list[id]['model_name'] = state.list[id]['model_name'].toLowerCase();
      if(post['content']) state.list[id]['is_ready_inner_page'] = true;
    },
    //Удалить пост из списка
    toRemovePostFromList(state, id){
      const mapKey = formatTime_yn_mn_dn(state.list[id]['publication_date']);
      state.renderMap[mapKey] = state.renderMap[mapKey].filter(item => item !== id);
      delete state.list[id];
      if(state.renderMap[mapKey].length <= 0) delete state.renderMap[mapKey];
    },
    //Очистить список рендера
    clearData(state){
      state.renderMap = {};
    },
    //Включить/отключить режим редактирования для редактора
    toToggleEditMode(state, { is_edit_mode, object_id }){
      state.isEditMode = is_edit_mode || false;
      state.editPostId = object_id;
    },
    //Обновить данные поста
    toChangePost(state, data){
      state.list[data.id].content = data.content;
      state.list[data.id].images_list = data.images_list;
      state.list[data.id].title = data.title;
      state.list[data.id].embed_links = data.embed_links;
    },
    //Добавить/удалить ифнормацию о присвоинных каналах к посту
    toChangeChannelInfo(state, { object_id, channel }){
      if(!state.list[object_id].channels) state.list[object_id].channels = [];
      const channels = state.list[object_id].channels;
      const index = (channels.length > 0) ? channels.findIndex(item => item.id === channel.id) : -1;
      (index !== -1) ? channels.splice(index, 1) : channels.push(channel);
    },
    //Обновить состояние реакций
    toChangeReactions(state, {object_id, reactions}){
      state.list[object_id].reactions.is_mine = reactions.is_mine;
      state.list[object_id].reactions.reactions_values = reactions.reactions_values;
    },
    //Обновить последний комментарий поста
    toChangeLastComment(state, {comment}){
      if(!state.list[comment.object_pk]) return;
      state.list[comment.object_pk].last_comment = comment;
    },
    //Увеличить счетчик комментариев
    toIncreaseCommentCount(state, { id, count }){
      if(!state.list[id]) return;
      state.list[id].comments_count = count;
      if(state.list[id].comments_count < state.list[id].init_comments_count){
        state.list[id].init_comments_count = count
      }
    },
    //Увеличить счетчик начальных комментариев
    toIncreaseInitCommentCount(state, { id }){
      state.list[id].init_comments_count++;
    },
    //Обновить счетчик новых комментариев
    toUpdateNewCommentsCounter(state, {id}){
      state.list[id].init_comments_count = state.list[id].comments_count;
    },
    //Зарегистрировать ID пришедшего коммента
    toRegisterIdNewComment(state, { id }){
      state.newCommentsId.push(id);
    },
    //Обновить статус isNew
    toUpdateNewStatus(state, id){
      state.list[id].is_new = false;
    }
  },

  getters:{
    //Получить строку параметров для запроса получения контента
    getContentIdString(state) {
      const idArray = [];
      for (const item in state.list) {
        if (!state.list[parseInt(item)].is_ready_inner_page) {
          idArray.push(parseInt(item));
        }
      }
      return idArray.length > 0 ? idArray.join(',') : null;
    }
  },
}